export const resetScroll = () => window.scrollTo(0, 0);

export const getBodyScroll = () => {
  return window.pageYOffset || document.documentElement.scrollTop;
};
